module.exports = new __parcel__URL__("gooh_refinery_level_1_v2.f86db09f.png").toString();